import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Replaces Turbo's native window.confirm() with a styled <dialog> modal.
// The message comes from each element's data-turbo-confirm attribute.
export default class extends Controller {
  static targets = ["dialog", "message"]

  connect() {
    const handler = (message) => this.ask(message)
    if (Turbo.config?.forms) {
      Turbo.config.forms.confirm = handler
    } else if (Turbo.setConfirmMethod) {
      Turbo.setConfirmMethod(handler)
    }
  }

  ask(message) {
    this.messageTarget.textContent = message
    this.dialogTarget.showModal()
    return new Promise((resolve) => {
      this.resolve = resolve
    })
  }

  accept() {
    this.settle(true)
  }

  cancel() {
    this.settle(false)
  }

  // Fires on Esc / backdrop close.
  dialogClosed() {
    this.settle(false)
  }

  settle(value) {
    if (this.resolve) {
      this.resolve(value)
      this.resolve = null
    }
    if (this.dialogTarget.open) this.dialogTarget.close()
  }
}
